export default __webpack_public_path__ + "static/media/kangaroo.42dc6855.ogg";